import { hasIntersection, isLoggedIn, parseDate } from "./utils";

export type Criteria = {
  tags?: string[];
  productIds?: string[];
  collectionIds?: string[];
};

const isCorrectUserScope = (scope?: ShopifyUserScope) => {
  switch (scope) {
    case "Logged Out Customers":
      return !isLoggedIn();
    case "Logged In Customers":
      return isLoggedIn();
    default:
      return true;
  }
};

export function checkConditions(conditions: Partial<ShopifyMetabojectConditions>, criteria: Criteria = {}) {
  const { tags = [], productIds = [], collectionIds = [] } = criteria;

  const hasNoConditions = !conditions?.tags && !conditions?.collections && !conditions?.products;
  const hasNoCriteria = !tags?.length && !collectionIds?.length && !productIds?.length;
  if (hasNoConditions || hasNoCriteria) return false;

  const now = Date.now();
  const startDate = parseDate(conditions.start_date);
  const endDate = parseDate(conditions.end_date);

  const results = {
    hasTags: hasIntersection({ a1: conditions.tags, a2: tags }),
    hasCollection: hasIntersection({ a1: conditions.collections, a2: collectionIds, normalise: true }),
    hasProduct: hasIntersection({ a1: conditions.products, a2: productIds, normalise: true }),
    hasCorrectScope: isCorrectUserScope(conditions.user_scope),
    hasStarted: startDate && now > startDate.getTime(),
    hasNotEnded: endDate && now < endDate.getTime(),
  };

  return Object.values(results).every((value) => value !== false);
}
